module.exports = ".container {\n  padding-left: 115px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/forgot-password/forgot-password.component.scss
// module id = ./src/app/pages/account/forgot-password/forgot-password.component.scss
// module chunks = main